import React from 'react';
import { getSessionEndedTitle } from '../../utils/aiSessionLabels';

/**
 * Shared teardown panel shown while the final report is being generated.
 * AI Interviewer and AI Counsellor share the finalize flow, so the panel takes
 * the active mode explicitly and keeps their headings independent.
 */
const SessionEndingNotice = ({ mode }) => (
  <div
    data-testid="avatar-teardown"
    style={{
      position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '24px',
      textAlign: 'center', background: '#0b1220', color: '#e2e8f0'
    }}
  >
    <div style={{ width: '38px', height: '38px', borderRadius: '50%', border: '3px solid rgba(148,163,184,0.25)', borderTopColor: '#3b82f6' }} />
    <div data-testid="session-ended-title" style={{ fontSize: '15px', fontWeight: '700' }}>
      {getSessionEndedTitle(mode)}
    </div>
    <div style={{ fontSize: '12.5px', color: '#94a3b8', maxWidth: '360px', lineHeight: '1.5' }}>
      Generating and saving your AI evaluation report. This page switches to your report as soon as it is saved.
    </div>
  </div>
);

export default SessionEndingNotice;
